/*
 * `notReady` marks a bench that exists but is not fit to be opened yet. The
 * card renders as inert rather than being dropped, so the harness stays
 * visible as pending work instead of silently disappearing from the index.
 */
export const devComponents = [
    {
        slug: 'fight-stage',
        titleKey: 'dev.cards.fightStage.title',
        descriptionKey: 'dev.cards.fightStage.description',
        category: 'combat',
        component: () => import('@/views/Dev/FightStagePreview.vue'),
    },
    {
        slug: 'character-card',
        titleKey: 'dev.cards.characterCard.title',
        descriptionKey: 'dev.cards.characterCard.description',
        category: 'character',
        component: () => import('@/views/Dev/CharacterCardPreview.vue'),
    },
    {
        slug: 'duel-bench',
        titleKey: 'dev.cards.duelBench.title',
        descriptionKey: 'dev.cards.duelBench.description',
        category: 'combat',
        requiresAuth: true,
        component: () => import('@/views/Dev/DuelLab.vue'),
    },
    {
        slug: 'impact-lab',
        titleKey: 'dev.cards.impactLab.title',
        descriptionKey: 'dev.cards.impactLab.description',
        category: 'gm',
        requiresAuth: true,
        component: () => import('@/views/Dev/ImpactLab.vue'),
    },
    {
        slug: 'player-profile',
        titleKey: 'dev.cards.playerProfile.title',
        descriptionKey: 'dev.cards.playerProfile.description',
        category: 'character',
        requiresAuth: true,
        component: () => import('@/views/Dev/PlayerProfilePreview.vue'),
    },
    {
        slug: 'world-map-editor',
        titleKey: 'dev.cards.worldMapEditor.title',
        descriptionKey: 'dev.cards.worldMapEditor.description',
        category: 'world',
        component: () => import('@/views/Dev/WorldMapEditorPreview.vue'),
    },
    {
        slug: 'campaign-showcase',
        titleKey: 'dev.cards.campaignShowcase.title',
        descriptionKey: 'dev.cards.campaignShowcase.description',
        category: 'system',
        component: () => import('@/views/Dev/CampaignShowcasePreview.vue'),
    },
    {
        slug: 'character-showcase',
        titleKey: 'dev.cards.characterShowcase.title',
        descriptionKey: 'dev.cards.characterShowcase.description',
        category: 'character',
        component: () => import('@/views/Dev/CharacterShowcasePreview.vue'),
    },
    {
        slug: 'timeline',
        titleKey: 'dev.cards.timeline.title',
        descriptionKey: 'dev.cards.timeline.description',
        category: 'system',
        notReady: true,
        component: () => import('@/components/Timeline/TimelineView.vue'),
    },
    {
        slug: 'spray-pattern-modal',
        titleKey: 'dev.cards.sprayPatternModal.title',
        descriptionKey: 'dev.cards.sprayPatternModal.description',
        category: 'gm',
        component: () => import('@/views/Dev/SprayPatternModalPreview.vue'),
    },
    {
        slug: 'tactical-preview-grid',
        titleKey: 'dev.cards.tacticalPreviewGrid.title',
        descriptionKey: 'dev.cards.tacticalPreviewGrid.description',
        category: 'gm',
        component: () => import('@/views/Dev/TacticalPreviewGridPreview.vue'),
    },
    {
        slug: 'battle-map-3d',
        titleKey: 'dev.cards.battleMap3d.title',
        descriptionKey: 'dev.cards.battleMap3d.description',
        category: 'combat',
        component: () => import('@/views/Dev/BattleMap3DPreview.vue'),
    },
    {
        slug: 'skill-metrics',
        titleKey: 'dev.cards.skillMetrics.title',
        descriptionKey: 'dev.cards.skillMetrics.description',
        category: 'gm',
        component: () => import('@/views/Dev/SkillMetricsPreview.vue'),
    },
    {
        slug: 'puzzle-power',
        titleKey: 'dev.cards.puzzlePower.title',
        descriptionKey: 'dev.cards.puzzlePower.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/PowerDistributionPreview.vue'),
    },
    {
        slug: 'puzzle-lab',
        titleKey: 'dev.cards.puzzleLab.title',
        descriptionKey: 'dev.cards.puzzleLab.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/PuzzleLab.vue'),
    },
    {
        slug: 'puzzle-circuit',
        titleKey: 'dev.cards.puzzleCircuit.title',
        descriptionKey: 'dev.cards.puzzleCircuit.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/CircuitRoutingPreview.vue'),
    },
    {
        slug: 'puzzle-path',
        titleKey: 'dev.cards.puzzlePath.title',
        descriptionKey: 'dev.cards.puzzlePath.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/HolographicPathPreview.vue'),
    },
    {
        slug: 'puzzle-rune-cipher',
        titleKey: 'dev.cards.puzzleRuneCipher.title',
        descriptionKey: 'dev.cards.puzzleRuneCipher.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/RuneCipherPreview.vue'),
    },
    {
        slug: 'puzzle-station-deck',
        titleKey: 'dev.cards.puzzleStationDeck.title',
        descriptionKey: 'dev.cards.puzzleStationDeck.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/PuzzleStationDeck.vue'),
    },
    {
        slug: 'puzzle-knowledge-text',
        titleKey: 'dev.cards.puzzleKnowledgeText.title',
        descriptionKey: 'dev.cards.puzzleKnowledgeText.description',
        category: 'puzzles',
        component: () => import('@/views/Dev/puzzles/KnowledgeTextPreview.vue'),
    },
];

const devComponentsBySlug = new Map(devComponents.map(entry => [entry.slug, entry]));

export function findBySlug(slug) {
    return devComponentsBySlug.get(slug) ?? null;
}
